import { isArray } from 'lodash/fp';
import pt from 'prop-types';
import { Children, cloneElement } from 'react';
import { VectorDirection } from '@mews/enums';
import { notNil } from '@mews/fp';
import { MatrixVectorWrapperElement } from '../styles';
import { createCellDimensionGetters } from '../utils';

export const matrixVectorFactory = ({ MatrixVectorWrapper = MatrixVectorWrapperElement } = {}) => {
    const MatrixVector = ({
        cellHeight,
        cellWidth,
        children,
        collapsible,
        depth,
        nestedIndex,
        vectorDirection,
        vectorIndex,
        visibility,
        ...other
    }: $TSFixMe) => (
        <MatrixVectorWrapper vectorDirection={vectorDirection} {...other}>
            {Children.toArray(children)
                .filter(notNil)
                .map((cell, cellIndex) => {
                    if (!isArray(cellHeight) && !isArray(cellWidth)) {
                        // @ts-expect-error
                        return cloneElement(cell, { height: cellHeight, width: cellWidth });
                    }
                    const [getCellHeight, getCellWidth] = createCellDimensionGetters(
                        vectorDirection,
                        // @ts-expect-error $TSFixMeError: Expected 1 arguments, but got 3.
                        vectorIndex,
                        cellIndex
                    );
                    // @ts-expect-error
                    return cloneElement(cell, {
                        height: getCellHeight(cellHeight),
                        width: getCellWidth(cellWidth),
                    });
                })}
        </MatrixVectorWrapper>
    );

    MatrixVector.propTypes = {
        vectorDirection: pt.oneOf([VectorDirection.Row, VectorDirection.Column]),
        cellHeight: pt.oneOfType([pt.number, pt.arrayOf(pt.number)]),
        cellWidth: pt.oneOfType([pt.number, pt.arrayOf(pt.number)]),
        children: pt.node.isRequired,
    };

    return MatrixVector;
};

export default matrixVectorFactory();
